import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { initialiseAuthClient } from 'src/utils/online-identity';

import AuthContext from './AuthContext';

const AuthProvider = ({ children }: { children: any }) => {
  const location = useLocation();
  const { token: userToken } = queryString.parseUrl(location.search).query;

  const [authToken, setAuthToken] = useState<string | undefined>();
  const [authLoaded, setAuthLoaded] = useState<boolean>(false);
  const [xToken, setXToken] = useState<string | undefined>(
    (userToken as string) ?? undefined,
  );

  useEffect(() => {
    const initAuth = async () => {
      const getToken = initialiseAuthClient();
      let token;
      try {
        token = await getToken();
        if (token) {
          setAuthToken(token);
        }
      } catch {
        // Not actually an error, just means they are not logged in
      }
      setAuthLoaded(true);
      window.dataLayer.push({
        loginStatus: token ? 'LOGGED_IN' : 'LOGGED_OUT',
      });
    };
    // This is currently recommended but one day will be replaced with a new pattern
    // Word from react core maintainer - https://github.com/facebook/react/issues/14326
    initAuth();
  }, []);

  const value = {
    getAuthToken: () => authToken,
    setAuthToken,
    getXToken: () => xToken,
    setXToken,
    authLoaded,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
